$(function () {
    // @codekit-prepend 'js/functions.js'
    // @codekit-prepend 'js/slider.js'
    // @codekit-prepend 'js/email-camper.js'
    // @codekit-prepend 'js/accounts.js'
    // @codekit-prepend 'js/photos.js'
});